import { render, staticRenderFns } from "./RoomTemplate.vue?vue&type=template&id=13fa1538&scoped=true&"
import script from "./RoomTemplate.vue?vue&type=script&lang=ts&"
export * from "./RoomTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./RoomTemplate.vue?vue&type=style&index=0&id=13fa1538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa1538",
  null
  
)

export default component.exports